import { useCallback, useEffect, useState } from 'react'
import { getApiBaseUrl } from '@/app/config/settings'

export type TemplateListItem = {
  template_id: string
  flow_code: string
  flow_name?: string | null
  inspection_type: string
}

export type ListTemplatesResponse = {
  templates: TemplateListItem[]
}

export function useTemplates(getFirebaseToken: () => Promise<string | null>) {
  const [data, setData] = useState<ListTemplatesResponse | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  const fetchTemplates = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const token = await getFirebaseToken()
      const base = getApiBaseUrl()
      if (!base) {
        throw new Error('API base URL not configured')
      }
      const response = await fetch(`${base}/safetyculture/templates`, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      })
      if (!response.ok) {
        throw new Error(`Failed to load templates: ${response.status}`)
      }
      const json: ListTemplatesResponse = await response.json()
      setData(json)
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to load templates'))
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchTemplates()
  }, [fetchTemplates])

  return { data, isLoading, error, refresh: fetchTemplates }
}
